import React from 'react'

import { AuthContextInterface } from './types'

export const AuthContext = React.createContext<AuthContextInterface>({
  clearError() {
    throw new Error('Not implemented `clearError`')
  },
  confirmEmail() {
    throw new Error('Not implemented `confirmEmail`')
  },
  confirmTwoFactorAuth() {
    throw new Error('Not implemented `confirmTwoFactorAuth`')
  },
  disable2FaAuth() {
    throw new Error('Not implemented `disable2FaAuth`')
  },
  enable2FaAuth() {
    throw new Error('Not implemented `enable2FaAuth`')
  },
  error: null,
  init2FaAuth() {
    throw new Error('Not implemented `init2FaAuth`')
  },
  is2FaEnabledData: undefined,
  is2FaEnabledError: null,
  is2FaEnabledLoading: false,
  isAuthorizedData: undefined,
  isAuthorizedError: null,
  isAuthorizedLoading: false,
  isConfirmTwoFactorAuthLoading: false,
  isLocalLoading: false,
  isUserLoading: true,
  pushOnLogoutCallback() {
    throw new Error('Not implemented `pushOnLogoutCallback`')
  },
  refetchIs2FaEnabled() {
    throw new Error('Not implemented `refetchIs2FaEnabled`')
  },
  refetchIsAuthorized() {
    throw new Error('Not implemented `refetchIsAuthorized`')
  },
  removeOnLogoutCallback() {
    throw new Error('Not implemented `removeOnLogoutCallback`')
  },

  resetPassword() {
    throw new Error('Not implemented `resetPassword`')
  },
  resetPasswordRequest() {
    throw new Error('Not implemented `resetPasswordRequest`')
  },
  signIn() {
    throw new Error('Not implemented `signIn`')
  },
  signOut() {
    throw new Error('Not implemented `signOut`')
  },

  signUp() {
    throw new Error('Not implemented `signUp`')
  },
  user: undefined,
  userError: null,
  userRefetch() {
    throw new Error('Not implemented `userRefetch`')
  },
})
